import api from './api'

export interface LoginRequest {
  username: string
  password: string
}

export interface RegisterRequest {
  username: string
  email: string
  password: string
  full_name: string
  role?: string
  vet_id?: string | null
}

export interface UserUpdateRequest {
  email?: string
  full_name?: string
  role?: string
  is_active?: boolean
  vet_id?: string | null
}

export interface User {
  id: string
  username: string
  email: string
  full_name: string
  role: string
  is_active: boolean
  vet_id: string | null
}

export interface TokenResponse {
  access_token: string
  token_type: string
  user: User
}

export const authApi = {
  async login(data: LoginRequest): Promise<TokenResponse> {
    const response = await api.post<TokenResponse>('/auth/login', data)
    localStorage.setItem('auth_token', response.data.access_token)
    localStorage.setItem('auth_user', JSON.stringify(response.data.user))
    return response.data
  },

  async register(data: RegisterRequest): Promise<User> {
    const response = await api.post<User>('/auth/register', data)
    return response.data
  },

  async getMe(): Promise<User> {
    const response = await api.get<User>('/auth/me')
    return response.data
  },

  async listUsers(skip = 0, limit = 50): Promise<User[]> {
    const response = await api.get<User[]>('/auth/users', {
      params: { skip, limit },
    })
    return response.data
  },

  async getUserById(userId: string): Promise<User> {
    const response = await api.get<User>(`/auth/users/${userId}`)
    return response.data
  },

  async updateUser(userId: string, data: UserUpdateRequest): Promise<User> {
    const response = await api.patch<User>(`/auth/users/${userId}`, data)
    return response.data
  },

  async deleteUser(userId: string): Promise<void> {
    await api.delete(`/auth/users/${userId}`)
  },

  logout() {
    localStorage.removeItem('auth_token')
    localStorage.removeItem('auth_user')
  },

  getToken(): string | null {
    return localStorage.getItem('auth_token')
  },

  getUser(): User | null {
    const userStr = localStorage.getItem('auth_user')
    if (!userStr) return null
    try {
      return JSON.parse(userStr)
    } catch {
      return null
    }
  },
}

export default api
